/* tslint:disable */ import { Injectable, inject } from '@angular/core'; import
{ HttpClient } from '@angular/common/http'; import { ApiConfig } from
'../api-config'; /** * Base class for services */ @Injectable() export class
WorkflowBaseService
{ protected http = inject(HttpClient); protected apiConfig = inject(ApiConfig);
private _rootUrl = ''; /** * Returns the root url for all operations in
this service. If not set directly in this * service, will fallback to
`apiConfig.workflowApiBaseUrl`. */ get rootUrl():
string { return this._rootUrl || this.apiConfig.workflowApiBaseUrl; } /** * Sets the root URL for API operations in this service. */ set
rootUrl(rootUrl: string) { this._rootUrl = rootUrl; } }